import { z } from 'zod';
import { getEmbeddedCourseDtoSchema } from '../getEmbeddedCourseDtoSchema';

export const coursesControllerGetEmbeddedPathParamsSchema = z.object({
  id: z.string().uuid(),
});

export const coursesControllerGetEmbedded200Schema = z.lazy(
  () => getEmbeddedCourseDtoSchema,
);

export const coursesControllerGetEmbedded400Schema = z.object({
  statusCode: z.enum(['400']),
  message: z.string(),
  type: z.enum(['InvalidData']),
  details: z.object({
    location: z.enum(['path', 'query', 'body']),
    explanation: z.object({
      issues: z.array(
        z
          .object({
            code: z.enum([
              'invalid_type',
              'invalid_literal',
              'custom',
              'invalid_union',
              'invalid_union_discriminator',
              'invalid_enum_value',
              'unrecognized_keys',
              'invalid_arguments',
              'invalid_return_type',
              'invalid_date',
              'invalid_string',
              'too_small',
              'too_big',
              'invalid_intersection_types',
              'not_multiple_of',
              'not_finite',
            ]),
            path: z.array(z.union([z.string(), z.number()])),
            message: z.string(),
          })
          .catchall(z.unknown()),
      ),
    }),
  }),
});

export const coursesControllerGetEmbedded404Schema = z.object({
  statusCode: z.enum(['404']),
  message: z.string(),
  type: z.enum(['ObjectNotFound']),
  details: z.enum(['null']).nullable(),
});

export const coursesControllerGetEmbeddedQueryResponseSchema = z.lazy(
  () => getEmbeddedCourseDtoSchema,
);
